module.exports = __webpack_public_path__ + "img/icon-sti-sti-dest-pod-urgent-delivery.80f23aff.svg";